import { render } from "./Otp.vue?vue&type=template&id=57c21742"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__